<template>
    <div style="min-height: 400px;">
        <v-card class="mx-auto ma-15 pa-10 text-center" max-width="1200">
            <v-row>
                <v-col cols="3" class="mx-auto">
                    <v-img src="../../assets/admin/sad_face.png" height="100px" contain></v-img> 
                </v-col>
            </v-row>
            <v-spacer></v-spacer>            
            <v-card-text>
                <v-row align="center" class="mx-0">
                    <v-col class="">
                        <div class="text-h3 red--text">If your school has reached the limit of licenses, please contact your administrator or log in with an existing username.</div>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-spacer></v-spacer>
            <v-row>
                <v-col cols="6" class="mx-auto image-container">
                    <v-img src="../../assets/admin/barrier.png" class="responsive-image"></v-img>
                </v-col>
            </v-row>
        </v-card>
    </div>
</template>
<script>
import { db, functions } from '../../plugins/firebase'
export default {
    data() {
        return {
            code: ''
        }
    },
    methods: {
        
    },
}
</script>
<style scoped>
.image-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 400px; /* o la altura que prefieras */
}

.responsive-image {
    max-width: 100%;
    height: auto;
}
</style>